import { reduxMapTypes } from 'src/types';
import {
  BULK_SET_ACTIVE_TABS,
  RESET_ACTIVE_TABS,
  SET_ACTIVE_TAB,
  SET_MAP_IMAGE_URL,
  SET_MAP_LAST_CENTER,
  SET_MAP_ZOOM,
  TOGGLE_ACTIVE_TAB,
  TOGGLE_CROP_ACTIVE,
  SET_ACTIVE_LAYER,
  SET_MAP_VIEW_STATE,
  SET_MAP_VISUAL_SETTINGS,
  SET_AVAILABLE_LAYERS,
} from 'src/app/redux/redux-types';
import L from 'leaflet';
import { BarChoosenEnum } from 'src/enums/bar.enum';
import { layers } from 'src/configs/layers';
import { MapViewState } from 'src/enums/map.enum';

export const mapDefaultState: reduxMapTypes.StateType = {
  matrixSettings: undefined,
  activeTabs: {
    ch: false,
    sitrep: false,
    ruler: false,
    threed: false,
    magnifier: false,
    misrep: false,
    intrep: false,
    theaterEditor: false,
    filter: false,
    strategies: false,
    commandQueue: false,
    comao: false,
    editMode: false,
    report: false,
  },
  cropMap: {
    isCrop: false,
    croppedImageUrl: '',
    imageUrl: '',
  },
  mapZoom: 2,
  unitWeaponRange: undefined,
  mapLastCenter: undefined,
  mapEditModeLayers: [],
  mapVisualSettings: undefined,
  mapViewState: MapViewState.Default,
  availableLayers: [],
  activeLayer: undefined,
};

export const mapReducer = (state = mapDefaultState, action: reduxMapTypes.ActionType): reduxMapTypes.StateType => {
  switch (action.type) {
    // case SET_EDIT_COMMAND_PROPS:
    //   return {
    //     ...state,
    //     editCommandProps: action.payload,
    //   };
    // case MAP_MATRIX_IS_SET:
    //   return {
    //     ...state,
    //     matrixSettings: action.payload,
    //   };
    case BULK_SET_ACTIVE_TABS:
      return {
        ...state,
        activeTabs: action.payload,
      };
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTabs: {
          ...state.activeTabs,
          [action.payload.key]: action.payload.bool,
        },
      };
    case TOGGLE_ACTIVE_TAB:
      return {
        ...state,
        activeTabs: {
          ...state.activeTabs,
          [action.payload.key]: !state.activeTabs[action.payload.key],
        },
      };
    case RESET_ACTIVE_TABS:
      return {
        ...state,
        activeTabs: { ...mapDefaultState.activeTabs },
      };
    case SET_ACTIVE_LAYER:
      return {
        ...state,
        activeLayer: action.payload,
      };
    // case TOGGLE_CROP_ACTIVE:
    //   return {
    //     ...state,
    //     cropMap: {
    //       ...state.cropMap,
    //       isCrop: action.payload,
    //     },
    //   };
    // case SET_MAP_IMAGE_URL:
    //   return {
    //     ...state,
    //     cropMap: {
    //       ...state.cropMap,
    //       imageUrl: action.payload,
    //     },
    //   };
    case SET_MAP_ZOOM:
      return {
        ...state,
        mapZoom: action.payload,
      };
    case SET_MAP_LAST_CENTER:
      return {
        ...state,
        mapLastCenter: action.payload,
      };
    // case DISPLAY_WEAPON_RANGE:
    //   return {
    //     ...state,
    //     unitWeaponRage: action.payload,
    //   };
    // case ADD_EDIT_MODE_LAYER:
    //   return {
    //     ...state,
    //     mapEditModeLayers: [...state.mapEditModeLayers, action.payload],
    //   };
    case SET_MAP_VIEW_STATE:
      return {
        ...state,
        mapViewState: action.payload || MapViewState.Default,
      };
    case SET_MAP_VISUAL_SETTINGS:
      return {
        ...state,
        mapVisualSettings: action.payload,
      };
    case SET_AVAILABLE_LAYERS:
      return {
        ...state,
        availableLayers: action.payload,
        activeLayer: state.activeLayer || action.payload.find((o) => o.isDefault)?.id,
      };
    default:
      return state;
  }
};
